// Library Methods
import { useTranslation } from "react-i18next";
import { useContext, useMemo } from "react";

// Contexts
import { ReportSectionContext } from "src/contexts/reports/ReportSectionContext";
import { useClinicContext } from "src/contexts/clinic/ClinicProvider";

// Utils
import {
  getReportEyeText,
  getTutorialCompletionText,
} from "src/utils/exams/examReportsHelper";
import { getLocalDateTimeWithZone } from "src/utils/date/dateHelper";

const useColorVisionColumns = () => {
  const { t } = useTranslation();
  const { clinicInfo } = useClinicContext();
  const { eyeType, duration, examReport } = useContext(ReportSectionContext);

  const localDateAndTimeWithZone = useMemo(
    () =>
      examReport?.timing?.start
        ? getLocalDateTimeWithZone(
            examReport.timing.start,
            clinicInfo?.timezone
          )
        : { date: "N/A", time: "N/A" },
    [examReport?.timing?.start, clinicInfo?.timezone]
  );

  const colorVisionColumns = useMemo(() => {
    const firstColumn = [
      {
        title: t("Eye"),
        value: getReportEyeText(eyeType, t),
        isBlueText: true,
      },
    ];

    const secondColumn = [
      {
        title: t("Tutorial"),
        value: getTutorialCompletionText(
          examReport?.postProcessing?.tutorialCompletionState,
          t
        ),
        isBlueText: false,
      },
    ];

    const thirdColumn = [
      { title: t("Date"), value: localDateAndTimeWithZone?.date },
      { title: t("Time_hour"), value: localDateAndTimeWithZone?.time },
      {
        title: t("Duration"),
        value: duration,
        isBlueText: true,
      },
    ];

    return { firstColumn, secondColumn, thirdColumn };
  }, [
    examReport?.postProcessing?.tutorialCompletionState,
    localDateAndTimeWithZone,
    eyeType,
    duration,
    t,
  ]);

  return { colorVisionColumns };
};

export default useColorVisionColumns;
